import { createAction, props } from '@ngrx/store';
import { IInvitedDirectorsAndAdminsResponse } from '../models/invited-directors-and-admin-response.model';
import { IInvitedDirectorsRequest } from '../models/invited-directors.model';

export const loadGetInvitedDirectors = createAction(
  '[GetInvitedDirectors] Load GetInvitedDirectors',
  props<{
    request: { businessId: string; payload: IInvitedDirectorsRequest };
  }>()
);

export const loadGetInvitedDirectorssSuccess = createAction(
  '[GetInvitedDirectors] Load GetInvitedDirectors Success',
  props<{ response: IInvitedDirectorsAndAdminsResponse }>()
);

export const loadGetInvitedDirectorssFailure = createAction(
  '[GetInvitedDirectors] Load GetInvitedDirectors Failure',
  props<{ error: Error | any }>()
);
